// Phase I0.3 — Stat primitive.
// label + numeric pair: label in 11px Bebas Neue uppercase, value in
// JetBrains Mono (default) or Bebas Neue display when `display` set.

import type { CSSProperties, ReactNode } from "react";

export interface StatProps {
  label: string;
  value: ReactNode;
  /** Optional sub-label rendered under the value. */
  sub?: ReactNode;
  /** Render value as Bebas Neue display (38px) instead of mono. */
  display?: boolean;
  /** Tint the value in saffron when true. */
  accent?: boolean;
  style?: CSSProperties;
}

export function Stat({ label, value, sub, display, accent, style }: StatProps) {
  return (
    <div style={{ ...style }}>
      <div
        style={{
          fontFamily: "var(--sa-font-stat)",
          fontSize: 11,
          letterSpacing: "0.18em",
          color: "var(--sa-fg-muted)",
          textTransform: "uppercase",
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontFamily: display ? "var(--sa-font-stat)" : "var(--sa-font-mono)",
          fontSize: display ? 30 : 14,
          lineHeight: display ? 1 : 1.2,
          color: accent ? "var(--sa-accent-saffron)" : "var(--sa-fg-primary)",
          marginTop: 6,
        }}
      >
        {value}
      </div>
      {sub !== undefined && sub !== null ? (
        <div
          style={{
            fontFamily: "var(--sa-font-mono)",
            fontSize: 10,
            color: "var(--sa-fg-muted)",
            marginTop: 4,
          }}
        >
          {sub}
        </div>
      ) : null}
    </div>
  );
}
